import React from 'react';
import PropTypes from 'prop-types';
import WysiwygStyles from './wysiwygStyles';

const Wysiwyg = () => {};

Wysiwyg.defaultProps = {};

const WysiwygToolbar = props => {
  return (
    <WysiwygStyles.ToolbarStyles mt={props.mt} mb={props.mb}>
      {props.children}
    </WysiwygStyles.ToolbarStyles>
  );
};

WysiwygToolbar.propTypes = {
  children: PropTypes.node.isRequired,
  mb: PropTypes.number,
  mt: PropTypes.number,
};

WysiwygToolbar.defaultProps = {
  mt: undefined,
  mb: undefined,
};

const WysiwygToolbarItem = props => {
  return <WysiwygStyles.ToolbarItemStyles>{props.children}</WysiwygStyles.ToolbarItemStyles>;
};

WysiwygToolbarItem.propTypes = {
  children: PropTypes.node.isRequired,
};

Wysiwyg.Toolbar = WysiwygToolbar;
Wysiwyg.ToolbarItem = WysiwygToolbarItem;

export default Wysiwyg;
